import styles from './Header.module.scss'
import { useSelector } from 'react-redux'
import React from 'react'

export const Header = () => {
  const isIpOrAck = process.env.REACT_APP_IS_IP_OR_ACK === 'true'

  const url = window.location.href
  const urlOrgin = new URL(url).origin

  const finsovetnik =
    urlOrgin === process.env.REACT_APP_PROD_FA_URL ||
    urlOrgin === process.env.REACT_APP_TEST_FA_URL

  const result = useSelector((state) => state.result)

  const bindingProduct = result?.bind_required

  return (
    <div className={styles.root} data-testid="header">
      {isIpOrAck ? null : finsovetnik ? (
        <img
          data-testid="fs-logo"
          src="/FSlogo.png"
          alt=""
          className={styles.FSlogo}
        />
      ) : (
        <img
          data-testid="default-logo"
          src="/logo.png"
          alt=""
          className={styles.logo}
        />
      )}
      {!bindingProduct ? (
        <div data-testid="order-processing-header" className={styles.text}>
          Оформление заказа
        </div>
      ) : (
        <div data-testid="card-binding-header" className={styles.text}>
          Привязка карты
        </div>
      )}
    </div>
  )
}
